import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, PersonId } from '../../types/api/primaryKeys/PrimaryKey';
import { PersonPackageSummary } from '../../types/api/enrollmentPackages/PersonPackageSummary';
import { Package } from '../../types/api/enrollmentPackages/Package';
import { SignatureDataModel } from '../../types/api/enrollmentPackages/SignatureDataModel';
import { UpdatePackageProgressModel } from '../../types/api/enrollmentPackages/UpdatePackageProgressModel';
import { EnrollmentAssistant } from '../../types/api/enrollmentPackages/EnrollmentAssistant';

/** The main endpoint for getting package info (and steps). */
export async function getCurrentPackageInfoAndSteps(packageId: EnrollmentPackageId) {
	const result = await ApiRequest.get<Package>(`packages/${packageId}/steps`);
	return result;
}

/**
 * Retrieves all available packages for the provided person.
 * @param personId 
 */
export async function fetchPackageSummariesForPerson(personId: PersonId) {
	const result = await ApiRequest.get<PersonPackageSummary[]>(`people/${personId}/packages/`);
	return result;
}

/** Toggles the "use defined contributions" setting for the specified package. */
export async function togglePackageShoulsUseDefinedContributionSetting(packageId: EnrollmentPackageId) {
	await ApiRequest.put(`packages/${packageId}/toggleusedc`);
}

/** Adds the caller's signature to the package. */
export async function addSignatureToPackage(packageId: EnrollmentPackageId, signatureData: SignatureDataModel) {
	await ApiRequest.post(`packages/${packageId}/addsignature`, signatureData);
}

/** Updates package progress to the specified step. */
export async function updatePackageProgress(packageId: EnrollmentPackageId, stepNumber: number) {
	const requestBody: UpdatePackageProgressModel = {
		progress: stepNumber
	};

	await ApiRequest.post(`packages/${packageId}/progress`, requestBody);
}

export async function updatePackageEnrollmentAssistantData(packageId: EnrollmentPackageId, enrollmentAssistant: EnrollmentAssistant) {
	await ApiRequest.post(`packages/${packageId}/addenrollmentassistant`, enrollmentAssistant);
}